<b-container fluid="sm">
    <b-row class="pt-3">
        <b-col>
            <legend>Request Payment</legend>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="12" md="6">
            <div class="form-group">
                <p class="font-weight-bold">Customer Number</p>
                <vue-phone-number-input v-model="form.receiverNumber" default-country-code="ZA" no-example required
                    size="lg" maxlength="12" @update="ValidateReceiverNumber" />
                <div><span class="text-warning">{{form.valideReceiverNumberMessage}}</span></div>
            </div>
        </b-col>
        <b-col sm="12" md="6">
            <div class="form-group">
                <p class="font-weight-bold">Notify you on Number</p>
                <vue-phone-number-input v-model="form.senderNumber" default-country-code="ZA" required size="lg"
                    no-example maxlength="12" @update="ValidateSenderNumber" />
                <div><span class="text-warning">{{form.valideSenderNumberMessage}}</span></div>
            </div>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="12" md="6">
            <b-form-group label="Description">
                <b-form-input placeholder="Description" v-model="form.description">
                </b-form-input>
            </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
            <b-form-group label="Amount">
                <b-form-input type="number" step="0.01" min="0.00" max="99999.99" v-model='form.amount'
                    placeholder="Amount">
                </b-form-input>
            </b-form-group>
        </b-col>
    </b-row>
    <b-row>
        <b-col sm="12" md="6">
            <b-button type="button" @click="getProduct" variant="primary" class="my-4">
                Proceed
            </b-button>
        </b-col>
    </b-row>
    <div class="vld-parent">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    </div>
</b-container>